module.exports = __webpack_public_path__ + "img/person_mourong.3f1da0e5.jpg";